export default __webpack_public_path__ + "static/media/side_user.cbe629e8.svg";